import { render, staticRenderFns } from "./ChooseService.vue?vue&type=template&id=73c2b8b2&"
import script from "./ChooseService.vue?vue&type=script&lang=js&"
export * from "./ChooseService.vue?vue&type=script&lang=js&"
import style0 from "./ChooseService.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports